import { FC, useState } from "react";
import AnswersByDays from "./answersByDays";
import GeneralStatistics from "./generalStatistics";
import InteractionsByCategories from "./interactionsByCategories";
import AverageTime from "./averageTime";
import { FilterStatus } from "../../../../../../types/filterStatusValue";

const ReviewTab: FC = () => {
  const [filterStatus, setFilterStatus] = useState<FilterStatus>(FilterStatus.ALL);

  return (
    <div>
      <GeneralStatistics showTitle />
      <AnswersByDays filterStatus={filterStatus} setFilterStatus={setFilterStatus} />
      <InteractionsByCategories filterStatus={filterStatus} />
      <AverageTime filterStatus={filterStatus} />
    </div>
  );
};

export default ReviewTab;
